<template lang="pug">
.container.cardGeral
  .card.marginTop
    .card-header.titulo.sizeFonte {{tituloPesquisa}}
    .card-body
      .searchPanel
        .simpleSearch(v-if="searchObject.simpleSearch", key="simpleSearch")
          form(@submit.prevent="$emit('search', searchObject.simpleFieldValue)")
            el-input(
              :placeholder="placeHolder",
              v-model="searchObject.simpleFieldValue",
              @input="$emit('input', searchObject.simpleFieldValue)",
            )
              el-button.btn(
                slot="append",
                @click="$emit('search', searchObject.simpleFieldValue)"
              )
                i.fal.fa-search

        .advancedSearch(v-if="!searchObject.simpleSearch")
          form(@submit.prevent="$emit('search', searchObject.simpleFieldValue)")
            .panel
              el-row.labelDiv(:gutter="20")
                el-col.inputDiv(:span="12")
                  p.titulo Processo:
                  el-input(
                    v-model="searchObject.advancedObject.numeroProcesso",
                    v-mask="['#########/####']",
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                el-col.inputDiv(:span="12")
                  p.titulo CPF/CNPJ do interessado:
                  el-input(
                    v-model="searchObject.advancedObject.cpfCnpj",
                    class="input-with-select",
                    v-mask="['###.###.###-##', '##.###.###/####-##']",
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
              el-row.margin-top.labelDiv(:gutter="20")
                el-col.inputDiv(:span="12")
                  p.titulo Nome/Razão social do interessado:
                  el-input(
                    v-model="searchObject.advancedObject.nomeRazaoSocial",
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                el-col.inputDiv(:span="12")
                  p.titulo Tipo de processo:
                  el-select.full-width(
                    v-model='searchObject.advancedObject.tipo',
                    placeholder='Selecione',
                    clearable,
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                    el-option(
                      v-for='tipo in tipos',
                      :key='tipo.codigo',
                      :label='tipo.nome',
                      :value='tipo.codigo',
                      class="label-option"
                    )
              el-row.margin-top(:gutter="20" v-if="isPara")
                el-col.inputDiv(:span="12")
                  p.titulo Situação:
                  el-select.full-width(
                    v-model='searchObject.advancedObject.status',
                    placeholder='Selecione',
                    clearable,
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                    el-option(
                      v-for='statu in getStatusFormatted(statusPara)',
                      :key='statu.codigo',
                      :label='statu.nome',
                      :value='statu.codigo',
                      class="label-option"
                    )
              el-row.margin-top(:gutter="20" v-else)
                el-col.inputDiv(:span="12")
                  p.titulo Status:
                  el-select.full-width(
                    v-model='searchObject.advancedObject.status',
                    placeholder='Selecione',
                    clearable,
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                    el-option(
                      v-for='statu in status',
                      :key='statu.codigo',
                      :label='statu.nome',
                      :value='statu.codigo',
                      class="label-option"
                    )
        .button-group.marginTopSearch
          .right
            el-button.pesquisa.no-padding(
              type="text",
              @click="changePesquisa"
            ) {{ tipoPesquisa }}
            el-button.pesquisa.no-padding(
              type="text",
              @click="limpar"
            ) Limpar
          .right
            el-button.btn-action(
              v-if="!searchObject.simpleSearch",
              type="primary",
              size="small",
              @click="pesquisar"
            )
              i.fal.fa-search
              | &nbsp Pesquisar
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'

const advancedObject = {
  nomeRazaoSocial: '',
  tipo: '',
  cpfCnpj: '',
  numeroProcesso: '',
  status: ''
}

function sortStatus (status1, status2) {
  if (status1?.codigo > status2?.codigo) return 1
  return -1
}

export default {

  props: {
    placeHolder: {
      type: String,
      default: 'Informe o número ou o tipo de processo',
      required: false
    },

    responsaveis: {
      type: Array,
      required: false
    },
    statusRetificacao: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tipos: [],
      status: [
        {
          codigo: 'AGUARDANDO_ANALISE',
          nome: 'Aguardando análise'
        },
        {
          codigo: 'EM_ANALISE',
          nome: 'Em análise'
        },
        {
          codigo: 'ARQUIVADO',
          nome: 'Arquivado'
        },
        {
          codigo: 'FINALIZADO',
          nome: 'Finalizado'
        }
      ],
      searchObject: {
        simpleFieldValue: '',
        advancedObject: _.cloneDeep(advancedObject),
        simpleSearch: true
      },
      statusPara: '',
      statusFormatado: ''
    }
  },

  async created () {
    const filterInfo = await this.getFilterInfo()
    this.status = filterInfo?.status?.map(s => {
      return {
        codigo: s,
        nome: filterInfo.statusFormatado[s]
      }
    }).sort(sortStatus)
    this.statusPara = filterInfo.status
    this.statusFormatado = filterInfo.statusFormatado
    if (this.statusRetificacao) {
      const temStatusRetificacao = this.status.find(s => s.codigo === 'EM_RETIFICACAO')
      if (!temStatusRetificacao) {
        this.status.push({
          codigo: 'EM_RETIFICACAO',
          nome: 'Em retificação'
        })
        this.status = this.status.sort(sortStatus)
      }
    }
    const tiposProcessosExcluidos = ['GENERICO']
    this.tipos = await this.getTiposProcessosPromise()
    this.tipos = this.tipos.filter(tipoProcesso => !tiposProcessosExcluidos.includes(tipoProcesso.codigo))
    if (this.isMaranhao) {
      const tiposProcessosMaranhao = ['CANCELAMENTO_CLAUSULA_RESOLUTIVA', 'NAO_ONEROSO', 'ONEROSO', 'PEAS', 'TQ', 'REURB_COLETIVO', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO', 'REURB_INDIVIDUAL']
      this.tipos = this.tipos.filter(tipoProcesso => tiposProcessosMaranhao.includes(tipoProcesso.codigo))
      this.tipos.forEach(item => {
        if (item.codigo === 'NAO_ONEROSO_FISICO') {
          item.nome = 'Não oneroso(físico)'
        } else if (item.codigo === 'ONEROSO_FISICO') {
          item.nome = 'Oneroso(físico)'
        }
      })
    }
  },

  computed: {
    tipoPesquisa () {
      return this.searchObject.simpleSearch ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    },
    tituloPesquisa () {
      return this.searchObject.simpleSearch ? 'Pesquisa simplificada' : 'Pesquisa avançada'
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    isPara () {
      return process.env.ESTADO === 'pa'
    }
  },

  methods: {
    ...mapActions({
      getTiposProcessosPromise: 'processos/getTiposProcessosPromise',
      getFilterInfo: 'dashboardRelatorios/getFilterInfo'
    }),

    getStatusFormatted (control) {
      return _.orderBy(control)
        .filter(status => this.statusFormatado[status])
        .map((status1) => ({ nome: this.statusFormatado[status1], codigo: status1 }))
    },

    limpar () {
      if (this.searchObject.simpleSearch) {
        this.searchObject.simpleFieldValue = ''
      } else {
        this.searchObject.advancedObject = _.cloneDeep(advancedObject)
      }
      this.$emit('clear')
    },

    changePesquisa () {
      this.searchObject.simpleSearch = !this.searchObject.simpleSearch
    },

    pesquisar () {
      this.$emit('advancedSearch', this.searchObject.advancedObject)
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/_variables.scss";

  .searchPanel {
    display: flex;
    flex-direction: column;
    text-align: left;

    .button-group {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    .no-padding{
      padding: 0;
    }

    .panel{

      .margin-top{
        margin-top: 10px;
      }

      .titulo{
        font-size: 14px;
      }

    }

    .btn {
      color: $font-color;
    }

    .full-width {
      width: 100%;
    }

  }
  .label-option {
    font-family: Arial, Helvetica, sans-serif;
  }
  .titulo {
    color: #424242;
  }
  .sizeFonte {
    font-size: 1.5rem;
  }
  .marginTop {
    margin-top: 13px;
  }
  .marginTopSearch {
    margin-top: 12px;
  }

  @media (max-width: 780px) {
    .sizeFonte {
      flex-direction: row;
    }

    .labelDiv {
      display: flex;
      flex-direction: column;
    }
    .inputDiv {
      width: 100%;
    }

    .cardGeral{
      width: 310px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/SearchProcessos.vue